export enum AppMode {
    STANDALONE = 'Standalone',
    EMBEDDED_SINGLE_WIDGET = 'Embedded Single Widget',
    EMBEDDED_DASHBOARD = 'Embedded Dashboard',
}
